var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ArchivesInfo/ArchivesInfo.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ArchivesInfo/ArchivesInfo.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"ArchivesInfo ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"isLast"))) {
t_5 += "ArchivesInfo--last";
;
}
t_5 += "\">\n        <h2>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_5 += "</h2>\n        <figure>\n            <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"image")),"w680_url"), env.opts.autoescape);
t_5 += "\"\n              srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"image")),"w1366_url"), env.opts.autoescape);
t_5 += " 1366w,\n                      ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"image")),"w680_url"), env.opts.autoescape);
t_5 += " 680w\"\n              sizes=\"(max-width: 759px) 1, ";
t_5 += "\n                     100vw\"\n              alt=\"\">\n            <figcaption>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"imageCaption"), env.opts.autoescape);
t_5 += "</figcaption>\n        </figure>\n        <div>";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text")), env.opts.autoescape);
t_5 += "</div>\n        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button"))) {
t_5 += "\n            <div class=\"ArchivesInfo-button\">\n                <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"url"), env.opts.autoescape);
t_5 += "\" ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"noReload"))) {
t_5 += "class=\"u-Route\"";
;
}
t_5 += " ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"isNewTab"))) {
t_5 += "target=\"_blank\"";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"title"), env.opts.autoescape);
t_5 += "</a>\n            </div>\n        ";
;
}
t_5 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ArchivesInfo");
context.setVariable("ArchivesInfo", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ArchivesInfo/ArchivesInfo.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchivesInfo/ArchivesInfo.jinja
// module id = 474
// module chunks = 0